import Vue, { VNodeDirective, VNode } from 'vue'
import { debounce } from 'lodash'
import moment from 'moment'

import { DirectiveOptions } from 'vue';

interface ValueType {
  type: string,
  format?: string,
}

export default function (storeNamespace: string): DirectiveOptions {
  return {
    bind (el: HTMLElement, binding: VNodeDirective, vnode: VNode) {
      if (!vnode.context) {
        console.error('No context present on vm')
        return
      }

      if (!vnode.context.$store) {
        console.error(`No store instance is present on vm, did you forget to inject '$store'?`)
        return
      }

      let store = vnode.context.$store

      if (!el.hasAttribute('name')) {
        console.error(`Attribute 'name' must be specified on an element with v-field`)
        return
      }

      const nameItem = el.attributes.getNamedItem('name');
      if (!nameItem) {
        throw new Error('Element with v-field has no name attribute');
      }

      const fieldName = nameItem.value
      const deboundeTime = 500

      switch (el.tagName) {
        case 'SELECT': {
          (el as HTMLSelectElement).value = store.getters[`${storeNamespace}/fieldValue`](fieldName)

          el.onchange = (event) => {
            const value = (event.target as HTMLSelectElement).value
            store.commit(`${storeNamespace}/setFieldValue`, { fieldName, value })
          }

          break;
        }
        case 'INPUT': {
          const type = el.attributes.getNamedItem('type')
          let inputEl = el as HTMLInputElement

          const valueType = ((): ValueType => {
            if (!binding.value) {
              if (type) {
                return {
                  type: type.value
                }
              } else {
                return {
                  type: 'text',
                }
              }
            } else if (typeof binding.value === 'string') {
              return {
                type: binding.value,
              }
            } else {
              return binding.value
            }
          })();

          if (type && type.value === 'checkbox') {
            if (store.getters[`${storeNamespace}/fieldValue`](fieldName) === undefined && !inputEl.checked) {
              console.log('commit')
              store.commit(`${storeNamespace}/setFieldValue`, { fieldName, value: false })
            }

            el.onchange = event => {
              const value = (event.target as HTMLInputElement).checked
              store.commit(`${storeNamespace}/setFieldValue`, { fieldName, value })
            }
          } else {
            const handleChange = (event: Event) => {
              const value = (event.target as HTMLInputElement).value
              store.commit(`${storeNamespace}/setFieldValue`, { fieldName, value })
            }

            el.onchange = handleChange
            el.oninput = handleChange
          }

          break;
        }
        case 'TEXTAREA': {
          if (store.getters[`${storeNamespace}/fieldValue`](fieldName) === undefined) {
            store.commit(`${storeNamespace}/setFieldValue`, { fieldName, value: '' })
          }

          const handleChange = (event: Event) => {
            const value = (event.target as HTMLTextAreaElement).value
            store.commit(`${storeNamespace}/setFieldValue`, { fieldName, value })
          }

          el.onchange = handleChange;
          el.oninput = handleChange;

          break;
        }
        default: {
          console.warn(`Element ${el.tagName} not recognized`)
          break;
        }
      }
    },
  }
}
